import React, {PureComponent} from "react"

import {StatementItem} from "@irati/types"
import authentication from "@irati/auth"
import id from "@irati/utils/id"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import StatusType from "@irati/wallet/types/enums/Status"

import PrimaryDetails from "../PrimaryDetails"
import {StyledCard} from "../styled"

const DEFAULT_IMG = "https://res.cloudinary.com/perkbox/image/upload/v1561047597/4271b464-16f0-4e9a-8476-46a5b0576b63.png"

interface Props extends InjectIntl {
  statementItem: StatementItem
}

class SendCredit extends PureComponent<Props> {
  render() {
    const {statementItem, formatMessage} = this.props
    const {amount, sendCredit, currency} = statementItem.transfer
    const {sender, recipient} = sendCredit
    const isUserSender = authentication.user().uuid === sender?.uuid

    const title = isUserSender
      ? "wallet.statementItem.sendCredit.primaryDetails.title.sent"
      : "wallet.statementItem.sendCredit.primaryDetails.title.received"
    const subTitle = isUserSender
      ? "wallet.statementItem.sendCredit.primaryDetails.subTitle.sent"
      : "wallet.statementItem.sendCredit.primaryDetails.subTitle.received"
    const image = isUserSender ? recipient?.profile_img : sender?.profile_img
    const name = isUserSender ? firstnameLastname(recipient) : firstnameLastname(sender)

    const primaryDetails = {
      image: image || DEFAULT_IMG,
      title: formatMessage({id: title}),
      subTitle: formatMessage({id: subTitle}, {name}),
      amount,
      currency,
      status: isUserSender ? StatusType.SPENT : StatusType.CLEARED
    }
    const idNamespace = id("send-credit-statement-item", this.props)

    return (
      <StyledCard medium noBorder>
        <PrimaryDetails imgHeightAuto id={idNamespace} data={primaryDetails} />
      </StyledCard>
    )
  }
}

export default injectIntl(SendCredit)
